import usersAPI from '../../../api/users'

const mapOrder = (order) => {
  switch (order) {
  case 'info':
    return 'name'
  case 'joined':
    return 'created_at'
  default:
    return 'created_at'
  }
}

export default {
  async index({commit, state}, view) {
    commit('setFetchingForView', {view, value: true})

    const meta = state.views[view].meta

    const params = {}

    if (typeof(meta.archived) !== 'undefined' && meta.archived !== null) {
      params.archived = meta.archived
    }
    if (typeof(meta.active) !== 'undefined' && meta.active !== null) {
      params.active = meta.active
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    const resp = await usersAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async update({commit, state, dispatch}, {id, data}) {
    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    commit('setFetchingForView', {view: state._inactiveView, value: true})
    await usersAPI.update({id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
    dispatch('index', state._inactiveView)
  },

  async archive({state, commit, dispatch}, id) {
    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    commit('setFetchingForView', {view: state._inactiveView, value: true})
    await usersAPI.destroy({id})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
    dispatch('index', state._inactiveView)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js